export default {
    data() {
        return {
            isConfirm: true,
            leaveView: null,
            nextPath: '',
            opacity: 100,
        }
    },
    methods: {
        openModal(isConfirm) {
            this.isConfirm = isConfirm;
            this.$bvModal.show('modal-compound');
        },
        toBackCompoundView() {
            this.$router.push('/composto')
        },
        confirmLeaveView() {
            this.leaveView = true;
            this.$router.push(this.nextPath);
        },
    },
    beforeRouteLeave(to, from, next) {
        if(this.leaveView) {
            next();
        }
        else {
            this.$bvModal.show('modal-leave-view');
            this.nextPath = to.path;
        }
    },
    mounted() {
        this.leaveView = false;
    }
}